// Lazysizes
import 'lazysizes';

// Alpine bootup
import Alpine from "./alpine/imports.js";

Alpine();
